import { neutral60opacity10 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
import { scienceblue, white } from '../colors';
export var MuiTab = {
    styleOverrides: {
        root: {
            lineHeight: rem(30),
            paddingTop: rem(2),
            paddingBottom: 0,
            paddingInline: rem(8),
            '&:hover': {
                boxShadow: "inset 0 2px 0 ".concat(neutral60opacity10),
            },
            '&[class*=Mui-selected]': {
                boxShadow: "inset 0 2px 0 ".concat(scienceblue),
                backgroundColor: white,
            },
        },
    },
};
